module.exports = false;


//////////////////
// WEBPACK FOOTER
// /Users/mac/PlayGround/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0